import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { staticData } from "managers/staticDataManager";

import Cookies from "js-cookie";

const PopUpTerm = (params) => {
  const { channel } = useSelector((state) => state.staticData);
  const [showBanner, setShowBanner] = useState(false);
  // const [isMobileDevice, setIsMobileDevice] = useState(window.innerWidth <= 767);
  // const timeoutForMobileDevicesInMiliseconds = 20000;

  useEffect(() => {
    const popUp = Cookies.get("cookiePopUp");
    // console.log('channel?.popUpTerm: ', !channel?.popUpTerm);
    // console.log('channel?.popUpTerm != "": ', channel?.popUpTerm != '');
    // console.log('!popUp: ', !popUp);
    let result = channel?.popUpTerm && channel?.popUpTerm !== "" && !popUp;
    // console.log('PopUpTerm.showThePopUp-channel?.popUpTerm, popUp, result: ', channel?.popUpTerm, popUp, result);
    setShowBanner(result);
  }, [channel?.popUpTerm]);

  // useEffect(() => {
  //   if (!showBanner || !isMobileDevice) return;

  //   // Automatically close the popup after timeoutForMobileDevicesInMiliseconds if it's shown on a mobile device
  //   const timer = setTimeout(() => {
  //     closePopup();
  //   }, timeoutForMobileDevicesInMiliseconds);

  //   return () => clearTimeout(timer);
  // }, [showBanner, isMobileDevice]);

  const closePopup = () => {
    Cookies.set("cookiePopUp", "true", { expires: 2 });
    setShowBanner(false);
  };

  return (
    <div className="popupterm" hidden={!showBanner}>
      <div className="popupterm-content">
        <span className="popupterm-close" onClick={closePopup}>
          &times;
        </span>

        <div
          dangerouslySetInnerHTML={{
            __html: staticData.loadTerms(useSelector, channel?.popUpTerm),
          }}
        />
      </div>
    </div>
  );
};

export default PopUpTerm;
